import style from "./bg-image.module.scss";
import Image from "next/image";

export default function BackgroundImage({
  imageSettings,
  hasOverlay,
  overlayColor,
  textImageOpacity,
}) {
  if (!imageSettings) {
    return null;
  }

  return (
    <div className={`bgImage ${style.bgImage}`}>
      {hasOverlay && (
        <div
          className={style.bgOverlay}
          style={{ background: `${overlayColor}` }}
        ></div>
      )}

      <Image
        src={imageSettings["sourceUrl"]}
        width={500}
        height={500}
        alt={imageSettings["altText"] ?? ""}
        style={{ opacity: `${textImageOpacity}` }}
      />
    </div>
  );
}
